import React from 'react';
import "./index.less";
import "./nextCircleBtn.less";
var NextCircleBtn = function NextCircleBtn(props) {
  var onClick = props.onClick,
    style = props.style,
    disabled = props.disabled;
  var handleClick = function handleClick(e) {
    if (disabled) return;
    if (onClick !== null && onClick !== undefined) {
      onClick(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-circle-mobile-btn iron-circle-btn-right ".concat(disabled ? 'iron-button-disabled' : ''),
    onClick: handleClick,
    style: style
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05383 20.6339C8.19173 20.6346 8.32511 20.5848 8.42883 20.4939L17.0388 13.0289C17.1828 12.9132 17.2989 12.7666 17.3788 12.6C17.4586 12.4335 17.5 12.2511 17.5 12.0664C17.5 11.8817 17.4586 11.6993 17.3788 11.5328C17.2989 11.3662 17.1828 11.2196 17.0388 11.1039L8.42883 3.63891C8.37237 3.58999 8.30681 3.55267 8.23592 3.52909C8.16504 3.50551 8.09019 3.49612 8.01567 3.50145C7.94116 3.50679 7.86842 3.52676 7.80161 3.56021C7.73481 3.59366 7.67525 3.63994 7.62633 3.69641C7.57742 3.75288 7.5401 3.81843 7.51652 3.88932C7.49293 3.96021 7.48354 4.03505 7.48888 4.10957C7.49422 4.18409 7.51418 4.25682 7.54764 4.32363C7.58109 4.39043 7.62737 4.44999 7.68383 4.49891L16.2988 11.9589C16.3333 11.9842 16.3566 12.0218 16.3638 12.0639C16.3559 12.1071 16.3329 12.1461 16.2988 12.1739L7.68383 19.6389C7.57115 19.7381 7.50217 19.8778 7.49187 20.0276C7.48157 20.1774 7.53079 20.3252 7.62883 20.4389C7.68144 20.5001 7.74665 20.5492 7.82001 20.5829C7.89336 20.6165 7.97313 20.6339 8.05383 20.6339Z",
    fill: "#04AFFF"
  })));
};
NextCircleBtn.defaultProps = {
  onClick: undefined,
  style: undefined,
  disabled: false
};
export default NextCircleBtn;